<app-periodo-dashboard [periodos]="periodos" [periodoInicial]="periodoInicial" prefijo="periodo-ia" (cambio)="onPeriodo($event)">
  <div meta class="tickets-toolbar__meta">
    <span>{{ resumen.solicitudesPeriodo }} solicitudes IA recibidas</span>
    <strong>{{ rango.inicio | date:'dd/MM/yy' }} - {{ rango.fin | date:'dd/MM/yy' }}</strong>
  </div>
</app-periodo-dashboard>

<div class="tickets-alert" *ngIf="errorCarga">
  {{ errorCarga }}
</div>

<section class="tickets-kpis ia-kpis" aria-label="Indicadores principales de gobernanza de IA">
  <article class="ticket-kpi" *ngFor="let kpi of kpis" [ngClass]="kpi.className">
    <div class="ticket-kpi__icon">
      <mat-icon>{{ kpi.icon }}</mat-icon>
    </div>
    <div>
      <span>{{ kpi.label }}</span>
      <strong>{{ kpi.value }}</strong>
      <small>{{ kpi.meta }}</small>
    </div>
  </article>

  <div class="tickets-loading-card" *ngIf="cargando && kpis.length === 0">
    Actualizando indicadores...
  </div>
</section>

<section class="tickets-grid">
  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Solicitudes de IA en el periodo</span>
        <h2>Distribucion por estatus</h2>
      </div>
      <button type="button" class="tickets-link-button" *ngIf="puedeGestionarSolicitudes" (click)="abrirSolicitudes()">Ver tablero</button>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getSolicitudDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalSolicitudes }}</strong>
          <span>Recibidas</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of solicitudEstatusItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }}</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && solicitudEstatusItems.length === 0">
      No hay solicitudes de IA para el periodo seleccionado.
    </div>
  </article>

  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Incidencias IA abiertas en el periodo</span>
        <h2>Distribucion por estado</h2>
      </div>
      <button type="button" class="tickets-link-button" *ngIf="puedeVerIncidencias" (click)="abrirIncidencias()">Ver tablero</button>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getIncidenciaDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalIncidenciasPeriodo }}</strong>
          <span>Registradas</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of incidenciaEstadoItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }}</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && incidenciaEstadoItems.length === 0">
      No hay incidencias IA para el periodo seleccionado.
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Incidencias IA en el periodo</span>
        <h2>Por gravedad</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="gravedadItems.length > 0; else emptyGravedadTpl">
      <div class="tickets-bar" *ngFor="let item of gravedadItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre || 'Sin gravedad' }}</span>
          <strong>{{ getBarPercent(item, totalGravedad) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getBarStyle(item, i, totalGravedad)"></span>
        </div>
        <small>{{ item.valor }} incidencias</small>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Inventario activo - foto actual</span>
        <h2>Por ciclo de vida</h2>
      </div>
      <button type="button" class="tickets-link-button" *ngIf="puedeVerInventario" (click)="abrirInventario()">Ver inventario</button>
    </div>

    <div class="tickets-bars" *ngIf="cicloVidaItems.length > 0; else emptyCicloTpl">
      <div class="tickets-bar" *ngFor="let item of cicloVidaItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre || 'Sin ciclo' }}</span>
          <strong>{{ getBarPercent(item, totalCicloVida) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getBarStyle(item, i, totalCicloVida)"></span>
        </div>
        <small>{{ item.valor }} activos</small>
      </div>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Tendencia</span>
        <h2>Solicitudes IA por mes</h2>
      </div>
    </div>

    <div class="incident-months" *ngIf="solicitudMesItems.length > 0; else emptySolicitudMesTpl">
      <div class="incident-month" *ngFor="let item of solicitudMesItems; let i = index">
        <span>{{ item.nombre }}</span>
        <div class="incident-month__bar">
          <span [ngStyle]="getBarStyle(item, i, solicitudMesMax)"></span>
        </div>
        <strong>{{ item.valor }}</strong>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Tendencia</span>
        <h2>Incidencias IA por mes</h2>
      </div>
    </div>

    <div class="incident-months" *ngIf="incidenciaMesItems.length > 0; else emptyIncidenciaMesTpl">
      <div class="incident-month" *ngFor="let item of incidenciaMesItems; let i = index">
        <span>{{ item.nombre }}</span>
        <div class="incident-month__bar">
          <span [ngStyle]="getBarStyle(item, i, incidenciaMesMax)"></span>
        </div>
        <strong>{{ item.valor }}</strong>
      </div>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Activos IA en el periodo</span>
        <h2>Con mas incidencias</h2>
      </div>
    </div>

    <div class="tickets-area-list" *ngIf="activosIncidenciaItems.length > 0; else emptyActivosTpl">
      <div class="tickets-area" *ngFor="let item of activosIncidenciaItems; let i = index">
        <span class="tickets-area__rank">{{ i + 1 }}</span>
        <div>
          <strong>{{ item.nombre || 'Sin activo' }}</strong>
          <small>{{ item.valor }} incidencias</small>
        </div>
        <span class="tickets-area__percent">{{ getBarPercent(item, totalActivosIncidencias) }}%</span>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Lectura rapida - foto actual</span>
        <h2>Pendientes de gobernanza</h2>
      </div>
    </div>

    <div class="incident-summary">
      <div>
        <strong>{{ resumen.solicitudesSinResponsable }}</strong>
        <span>Solicitudes de IA pendientes que nadie ha tomado todavia.</span>
      </div>
      <div>
        <strong>{{ resumen.incidenciasCriticas }}</strong>
        <span>Incidencias IA criticas abiertas que requieren atencion inmediata.</span>
      </div>
      <div>
        <strong>{{ resumen.activosSinMonitoreo }}</strong>
        <span>Activos IA sin evaluacion de monitoreo en mas de {{ resumen.diasSinMonitoreo || 120 }} dias.</span>
      </div>
    </div>
  </article>
</section>

<section class="tickets-card tickets-card--table" *ngIf="puedeGestionarSolicitudes">
  <div class="tickets-card__header">
    <div>
      <span>Actividad reciente - foto actual</span>
      <h2>Ultimas solicitudes de IA</h2>
    </div>
    <button type="button" class="tickets-link-button" (click)="abrirSolicitudes()">Ver todas</button>
  </div>

  <div class="tickets-table-wrap" *ngIf="solicitudesRecientes.length > 0; else emptySolicitudesTpl">
    <table class="tickets-table">
      <thead>
        <tr>
          <th>Folio</th>
          <th>IA solicitada</th>
          <th>Area</th>
          <th>Estatus</th>
          <th>Fecha</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let solicitud of solicitudesRecientes">
          <td class="tickets-table__id">{{ solicitud.folio }}</td>
          <td>{{ solicitud.nombreIa }}</td>
          <td>{{ solicitud.area || 'Sin area' }}</td>
          <td>
            <span class="ticket-status" [ngClass]="getSolicitudEstatusClass(solicitud)">
              {{ getSolicitudEstatusLabel(solicitud) }}
            </span>
          </td>
          <td>{{ solicitud.fechaSolicitud }}</td>
          <td>
            <button type="button" class="tickets-table__action" (click)="abrirSolicitudes()" aria-label="Abrir tablero de solicitudes">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<ng-template #emptyGravedadTpl>
  <div class="tickets-empty">No hay incidencias IA por gravedad para el periodo.</div>
</ng-template>

<ng-template #emptyCicloTpl>
  <div class="tickets-empty">No hay activos IA en operacion en el inventario.</div>
</ng-template>

<ng-template #emptySolicitudMesTpl>
  <div class="tickets-empty">No hay solicitudes de IA por mes para el periodo.</div>
</ng-template>

<ng-template #emptyIncidenciaMesTpl>
  <div class="tickets-empty">No hay incidencias IA por mes para el periodo.</div>
</ng-template>

<ng-template #emptyActivosTpl>
  <div class="tickets-empty">Ningun activo IA registro incidencias en el periodo.</div>
</ng-template>

<ng-template #emptySolicitudesTpl>
  <div class="tickets-empty">No hay solicitudes de IA recientes para mostrar.</div>
</ng-template>
